// extracted by mini-css-extract-plugin
export default {"OptionalFieldsMessage":"style_OptionalFieldsMessage__MEFVH","PhoneInput":"style_PhoneInput__0rsld"};